import React from 'react';

/**
 * True when rendering content inside the Statement slide-out panel.
 * Used to disable nested “open in side panel”
 */
export const StatementSidePanelContext = React.createContext<boolean>(false);

export const useIsInStatementSidePanel = (): boolean => React.useContext(StatementSidePanelContext);
